<template lang="pug">
mixin fields(type)
  .ui.four.columns.grid.stackable.form
    .ui.field.column(v-for=`meter_key in $defines.meters.${type}.orders`)
      compare-input(v-model=`${type}.values[meter_key]`,
        :previous=`previous.${type}[meter_key]`,
        :label=`$defines.meters.${type}.meters[meter_key].label`
      )
    .ui.field.column(v-for=`(meter, meter_key) in $defines.meters.${type}.computed`)
      compare-input(v-model=`${type}.computed[meter_key]`,
        :previous=`previous.${type}[meter_key]`,
        :label=`meter.label`,
        :disabled='true'
      )

.form-record-meters
  h2 公寓水电表记录

  .ui.message
    .content
      .header 上次抄表时间
      p {{$formatters.date.to_datetime_cn(previous.time_created)}} ({{$formatters.date.from_now(previous.time_created)}})

  h3 水表
  +fields('water')

  h3 电表
  +fields('electricity')


  .ui.field.actions
    .ui.button.themed(@click='submit') 保存
    .ui.button(@click='cancel') 取消
</template>

<script>
import { MakeForm } from '../../utils'
import { CompareInput } from '../basic'

export default {
  name: 'form-record-meters',
  components: { CompareInput },
  data() {
    return {
      electricity: {
        values: {},
        computed: {},
      },
      water: {
        values: {},
        computed: {},
      },
    }
  },
  computed: {
    previous() {
      const records = this.$store.state.summary.meter_records || []
      return records[records.length - 1] || { electricity: {}, water: {} }
    },
  },
  created() {
    this.init()
  },
  watch: {
    'water.values': {
      deep: true,
      handler() {
        this.compute()
      },
    },
    'electricity.values': {
      deep: true,
      handler() {
        this.compute()
      },
    },
  },
  methods: {
    init() {
      this.$store.dispatch('load_meter_records', this)
      const types = ['electricity', 'water']
      for (const type of types) {
        for (const key of Object.keys(this.$defines.meters[type].computed))
          this.$set(this[type].values, key, '')
        for (const key of Object.keys(this.$defines.meters[type].meters))
          this.$set(this[type].values, key, '')
      }
    },
    compute() {
      const types = ['electricity', 'water']
      for (const type of types) {
        for (const key of Object.keys(this.$defines.meters[type].computed)) {
          const define = this.$defines.meters[type].computed[key]
          const expression = (define.expression || '').split(/(\+|-)/).map(t => t.trim())
          let balance = 0
          let op = '+'
          for (const exp of expression) {
            if (['-', '+'].includes(exp))
              op = exp
            else if (op === '+')
              balance += this[type].values[exp] || 0
            else if (op === '-')
              balance -= this[type].values[exp] || 0
          }
          this.$set(this[type].computed, key, balance)
        }
      }
    },
    payload() {
      this.compute()
      return {
        electricity: {
          ...this.electricity.values,
          ...this.electricity.computed,
        },
        water: {
          ...this.water.values,
          ...this.water.computed,
        },
      }
    },
    submit_form: MakeForm({
      type: 'post',
      url: 'meter_records',
      confirm: '确定提交？',
      payload() {
        return this.payload()
      },
      $afterSuccess() {
        this.$router.back()
      },
    }),
    submit() {
      this.submit_form()
    },
    cancel() {
      this.$router.back()
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormRecordMeters.vue?0a5d786b